<template>
  <div>
   <!-- <DateInput v-model="fecha" format="DD/MM/YYYY" />
   
    <DateInput v-model="fechaUSA" format="MM/DD/YYYY" />-->
  </div>
</template>

<script>
//import DateInput from '@/components/MedEZComponents/DateTime/DatePicker'

export default {
 // components: { DateInput },
  data() {
    return {
      fecha: null,
      fechaUSA: null
    };
  }
};
</script>